import { render, staticRenderFns } from "./stock-return.vue?vue&type=template&id=caa9c03a"
import script from "./stock-return.vue?vue&type=script&lang=js"
export * from "./stock-return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports